module.exports = __webpack_public_path__ + "img/744.e2b1dce6.jpg";